module.exports = __webpack_public_path__ + "c02b2dcbac2b3f85919575f1fb68a12d.svg";